/**
 * Constant for paginated queries that should display "all" items.
 */
export const MAX_PAGE_SIZE: number = 9999;
